import { SearchState } from 'src/hooks/meilisearch/types/search-state';

export const spacesKeys = {
  all: ['spaces'] as const,
  lists: () => [...spacesKeys.all, 'list'] as const,
  list: (
    directoryToken: string,
    page: number,
    perPage: number,
    searchState?: SearchState,
  ) =>
    [
      ...spacesKeys.lists(),
      directoryToken,
      page,
      perPage,
      searchState,
    ] as const,
};
